import * as TYPE from "../../actions/ActionConstants";

const initialState = {
  loading: false,
  error: false,
  message: "",
  requests: [],
  totalCount: 0,
};

const InstoreRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPE.IS_FETCHING:
      return {
        ...state,
        error: false,
        message: "",
        loading: action.payload,
      };
    case TYPE.GET_ALL_REQUESTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: "Requests fetch successfully",
        requests: action.payload.data,
        totalCount: action.payload.total_count,
      };
    case TYPE.GET_ALL_REQUESTS_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: "Error while fetching In Store Requests",
        requests: [],
      };

    case TYPE.CREATE_ACCEPT_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: action.payload,
        requests: [...state.requests, action.payload],
      };
    case TYPE.CREATE_ACCEPT_REQUEST_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: action.payload,
        requests: [],
      };
    case TYPE.USER_LOGOUT:
      return initialState;
    default:
      return state;
  }
};
export default InstoreRequestReducer;
